import {
	Avatar,
	Box,
	IconButton,
	Link,
	Tooltip,
	Typography,
} from "@material-ui/core";
import { deepOrange, green, grey, red, yellow } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";
import { Storefront } from "@material-ui/icons";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import CalendarIcon from "@material-ui/icons/CalendarToday";
import CallIcon from "@material-ui/icons/Call";
import CallMadeIcon from "@material-ui/icons/CallMade";
import CallReceivedIcon from "@material-ui/icons/CallReceived";
import DescriptionIcon from "@material-ui/icons/Description";
import LocalOfferOutlined from "@material-ui/icons/LocalOfferOutlined";
import MoneyOffIcon from "@material-ui/icons/MoneyOff";
import PermPhoneMsgIcon from "@material-ui/icons/PermPhoneMsg";
import PersonIcon from "@material-ui/icons/Person";
import RoomIcon from "@material-ui/icons/Room";
import WatchLaterIcon from "@material-ui/icons/WatchLater";
import clsx from "clsx";
import QRCode from "qrcode.react";
import React from "react";
import DynamicIcon from "../../commons/DynamicIcon";
import consts from "../../main/consts";
import { ORIGEM } from "../../main/origem";
import { STATUS, statusResolver } from "../../main/status";
import { isCarrierPackk } from "../../utils/check-carrier";
import { salesChannelIsAmericanas } from "../../utils/check-sales-channel";
import {
	calcTempoConfirmacao,
	getLabelDeliveryType,
	getLabelStatus,
	getTimeStrUtc,
	getTimeWithHourStr,
	useForceUpdate,
} from "./helpers";

const styles = (theme) => ({
	detail: {
		marginRight: theme.spacing(1),
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1),
		borderBottom: "1px dashed #CCC",
		color: grey[800],
		"&:last-child": {
			borderBottom: "none",
		},
	},
	rounded: {
		color: "#FFF",
		backgroundColor: grey[200],
	},
	icon: {
		width: 40,
		height: 40,
		color: grey[600],
	},
	notaFiscalAwaiting: {
		color: deepOrange[300],
	},
	iconButtom: {
		backgroundColor: grey[200],
	},
	roundedDelivery: {
		width: 34,
		height: 34,
		marginLeft: 2,
		color: "#FFF",
		backgroundColor: grey[600],
	},
	notPaid: {
		backgroundColor: red[400],
	},
	paid: {
		backgroundColor: green[400],
	},
	noMargin: {
		margin: 0,
	},
	qrCode: {
		margin: "20px auto ",
	},
	warning: {
		color: yellow[700],
	},
	textSubtitle: {
		lineHeight: "1.2 !important",
	},
	buttonAguardando: {
		backgroundColor: "transparent",
	},
});

const iconByDeliveryTypeMap = {
	EXTERNA: <CallMadeIcon fontSize="small" />,
	INTERNA: <ArrowForwardIcon fontSize="small" />,
	RETIRADA: <CallReceivedIcon fontSize="small" />,
};

function Details(props) {
	const {
		tempoConfirmacao,
		associado,
		recebedor,
		status,
		motivo,
		cliente,
		pago,
		pagamentoStatus,
		origem,
		tipoEntrega,
		notaFiscal,
		notaFiscalDevolucao,
		numero,
		codigoExterno,
		distancia,
		classes,
		theme,
		page,
		deliveryToken,
		deEntregaEstimada,
		dhEntregaEstimada,
		eventos,
		erpOrigem,
		canalDeVendas,
		transportadora,
	} = props;
	const colorStatus = theme.palette.pages[status];

	const getQRCode = (nf) => {
		if (nf && nf.emitida) {
			if (!numero && !codigoExterno && !origem && !nf) return "";

			if (nf && numero && origem && codigoExterno) {
				var string = consts.NOTA_FISCAL_URL + nf.chave;

				return (
					<Box display="flex" p={0} className={classes.detail}>
						<center className={classes.qrCode}>
							<QRCode value={string} />
						</center>
					</Box>
				);
			} else {
				return "";
			}
		}
	};

	const documentsMask = (document, documentType) => {
		if (document) {
			let documentTreated = "";
			if (
				documentType === "cliente" ||
				documentType === "recebedor" ||
				documentType === "cnpj"
			) {
				const cpfValidation = document.replace(/\D/g, "");

				const cnpjValidation = document
					.replace(/[^a-zA-Z0-9]/g, "")
					.toUpperCase();

				if (cpfValidation.length === 11) {
					documentTreated = cpfValidation
						.replace(/(\d{3})(\d)/, "$1.$2")
						.replace(/(\d{3})(\d)/, "$1.$2")
						.replace(/(\d{3})(\d{1,2})/, "$1-$2")
						.replace(/(-\d{2})\d+?$/, "$1");
				} else if (cnpjValidation.length === 14) {
					documentTreated = cnpjValidation.replace(
						/^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})$/,
						"$1.$2.$3/$4-$5",
					);
				} else {
					documentTreated = document;
				}
			} else if (documentType === "tel") {
				const telValidation = document.replace(/\D/g, "");

				if (telValidation.length === 8) {
					documentTreated = telValidation.replace(/(\d{4})(\d)/, "$1-$2");
				} else if (telValidation.length === 9) {
					documentTreated = telValidation.replace(/(\d{5})(\d)/, "$1-$2");
				} else if (telValidation.length === 10) {
					documentTreated = telValidation
						.replace(/(\d{2})(\d)/, "($1) $2")
						.replace(/(\d{4})(\d)/, "$1-$2");
				} else if (telValidation.length === 11) {
					documentTreated = telValidation
						.replace(/(\d{2})(\d)/, "($1) $2")
						.replace(/(\d{5})(\d)/, "$1-$2");
				} else if (telValidation.length === 12) {
					documentTreated = telValidation
						.replace(/(\d{2})(\d)/, "+$1 $2")
						.replace(/(\d{2})(\d)/, "($1) $2")
						.replace(/(\d{4})(\d)/, "$1-$2");
				} else if (telValidation.length === 13) {
					documentTreated = telValidation
						.replace(/(\d{2})(\d)/, "+$1 $2")
						.replace(/(\d{2})(\d)/, "($1) $2")
						.replace(/(\d{5})(\d)/, "$1-$2");
				} else {
					documentTreated = document;
				}
			} else {
				documentTreated = document;
			}

			return documentTreated;
		}
	};

	const distanciaString = ((d) => {
		const a = Number(d);
		if (isNaN(a)) {
			return false;
		}

		if (a >= 1) {
			return `${a.toFixed(2)} km`;
		}

		return `${(a * 1000).toFixed(2)} m`;
	})(distancia);

	const callPhone = (phone) => {
		window.open(`tel:${phone}`);
	};

	const forceUpdate = useForceUpdate();
	React.useEffect(() => {
		const interval = setInterval(() => {
			forceUpdate();
		}, 60000);

		return () => {
			clearInterval(interval);
		};
	});

	const calcConfirmacao = calcTempoConfirmacao(tempoConfirmacao);

	const aguardandoEvento = (events, status) => {
		const eventStatus = events.map((event) => event.status);
		if (
			status !== "CANCELADO" &&
			status !== "RECUSADO" &&
			eventStatus.includes("PENDING")
		) {
			return true;
		} else return false;
	};

	const eventMessage = (eventos) => {
		return eventos
			.filter((e) => e.tipo !== "ENTREGUE" && e.status === "PENDING")
			.map((e) => e.mensagem);
	};

	return (
		<>
			<Box display="flex" p={0} className={classes.detail}>
				<Box width={56} minWidth={56}>
					<Avatar
						className={classes.rounded}
						style={{ backgroundColor: colorStatus, padding: 6 }}
					>
						<DynamicIcon icon={status} variant="small" />
					</Avatar>
				</Box>
				<Box flexGrow={1}>
					<Typography variant="subtitle2" style={{ marginBottom: -6 }}>
						Status atual
					</Typography>
					<Typography variant="subtitle1" style={{ color: colorStatus }}>
						{getLabelStatus[status]}
					</Typography>
					{eventos &&
						status &&
						aguardandoEvento(eventos, status) &&
						eventMessage(eventos).map((menssagem, index) => {
							return <Typography variant="subtitle2">{menssagem}</Typography>;
						})}
					{motivo && motivo.length > 0 && (
						<>
							<Typography
								variant="subtitle2"
								className={classes.textSubtitle}
								style={{ marginBottom: -6 }}
							>
								Motivo:{" "}
								<Typography className={classes.textSubtitle} variant="caption">
									{motivo[motivo.length - 1].texto}
								</Typography>
							</Typography>
						</>
					)}
					{origem === "SHIP_FROM_STORE" &&
						status === "returned" &&
						deliveryToken &&
						deliveryToken.tokenInsucesso && (
							<Typography
								variant="subtitle2"
								className={classes.textSubtitle}
								style={{ marginTop: 10 }}
							>
								Código Entregador:{" "}
								<Typography
									className={classes.textSubtitle}
									variant="caption"
									style={{ color: colorStatus, fontSize: 17 }}
								>
									{deliveryToken.tokenInsucesso}
								</Typography>
							</Typography>
						)}
				</Box>
			</Box>
			{canalDeVendas && (
				<Box display="flex" p={0} className={classes.detail}>
					<Box width={56} minWidth={56}>
						<Storefront fontSize="large" className={classes.icon} />
					</Box>
					<Box flexGrow={1}>
						<Typography variant="subtitle2">Canal de venda:</Typography>
						<Typography variant="subtitle2">{canalDeVendas}</Typography>
					</Box>
				</Box>
			)}
			{dhEntregaEstimada && (
				<Box display="flex" p={0} className={classes.detail}>
					<Box width={56} minWidth={56}>
						<CalendarIcon fontSize="large" className={classes.icon} />
					</Box>
					<Box flexGrow={1}>
						<Typography variant="subtitle2">Entrega Estimada:</Typography>
						<Typography variant="subtitle2">
							Data:{" "}
							{salesChannelIsAmericanas(canalDeVendas)
								? getTimeStrUtc(dhEntregaEstimada)
								: getTimeWithHourStr(dhEntregaEstimada)}
						</Typography>
						{deEntregaEstimada && (
							<Typography variant="subtitle2">
								Turno: {deEntregaEstimada}
							</Typography>
						)}
					</Box>
				</Box>
			)}
			{origem !== "PEGUE_NA_LOJA" && (
				<Box display="flex" p={0} className={classes.detail}>
					<Box width={56} minWidth={56}>
						<WatchLaterIcon fontSize="large" className={classes.icon} />
					</Box>
					<Box flexGrow={1}>
						<Typography variant="subtitle2">Tempo para Confirmação:</Typography>
						<Typography variant="subtitle1">
							{calcConfirmacao.dateTime}
						</Typography>
					</Box>
				</Box>
			)}

			{distanciaString && (
				<Box display="flex" p={0} className={classes.detail}>
					<Box width={56} minWidth={56}>
						<RoomIcon fontSize="large" className={classes.icon} />
					</Box>
					<Box flexGrow={1}>
						<Typography variant="subtitle2">Distância:</Typography>
						<Typography variant="subtitle1">{distanciaString}</Typography>
					</Box>
				</Box>
			)}
			{origem !== "PEGUE_NA_LOJA" && (
				<Box display="flex" p={0} className={classes.detail}>
					<Box width={56} minWidth={56}>
						<Avatar className={classes.roundedDelivery}>
							{iconByDeliveryTypeMap[tipoEntrega]}
						</Avatar>
					</Box>
					<Box flexGrow={1} display="flex" gridGap={24}>
						<Box>
							<Typography variant="subtitle2">Tipo de entrega:</Typography>
							<Typography variant="subtitle1">
								{!isCarrierPackk(transportadora) && transportadora !== ""
									? "Externa: Transportadora"
									: getLabelDeliveryType(tipoEntrega)}
							</Typography>
							{tipoEntrega === "RETIRADA" &&
								status === statusResolver[STATUS.PRONTO_PARA_SAIR] && (
									<Typography variant="body2">
										Aguardando retirada do cliente
									</Typography>
								)}
						</Box>
						{transportadora && (
							<Box>
								<Typography variant="subtitle2">Transportadora:</Typography>
								<Typography
									variant="subtitle1"
									style={{ textTransform: "capitalize" }}
								>
									{transportadora.toLowerCase()}
								</Typography>
							</Box>
						)}
					</Box>
				</Box>
			)}

			{![
				statusResolver[STATUS.CANCELADO],
				statusResolver[STATUS.FINALIZADO],
				statusResolver[STATUS.DEVOLVIDO],
			].includes(status) &&
				origem !== "SHIP_FROM_STORE" &&
				origem !== "PEGUE_NA_LOJA" && (
					<Box display="flex" p={0} className={classes.detail}>
						<Box width={56} minWidth={56}>
							{pago && (
								<Avatar className={clsx(classes.roundedDelivery, classes.paid)}>
									<AttachMoneyIcon fontSize="small" />
								</Avatar>
							)}
							{!pago && (
								<Avatar
									className={clsx(classes.roundedDelivery, classes.notPaid)}
								>
									<MoneyOffIcon fontSize="small" />
								</Avatar>
							)}
						</Box>
						<Box flexGrow={1}>
							<Typography variant="subtitle2">Pagamento:</Typography>
							{pago && <Typography variant="subtitle1">Pedido pago</Typography>}
							{!pago && (
								<Typography
									variant="subtitle1"
									className={classes.textSubtitle}
								>
									{pagamentoStatus === "nao_aprovado"
										? "Pagamento não aprovado"
										: "Aguardando confirmação do pagamento"}
								</Typography>
							)}
						</Box>
					</Box>
				)}

			<Box display="flex" p={0} className={classes.detail}>
				<Box width={56} minWidth={56}>
					<PermPhoneMsgIcon fontSize="large" className={classes.icon} />
				</Box>
				<Box flexGrow={1}>
					<Typography variant="subtitle2">Fale com o cliente</Typography>
					<Typography variant="body1">
						{documentsMask(cliente.telefone, "tel")}
					</Typography>
					{cliente.customerId && (
						<Tooltip title="O Botmaker é um sistema separado do Maestro (abrirá em nova aba)">
							<Typography className={classes.link}>
								<Link
									href={`${consts.BOTMAKER_BASE_URL}${cliente.customerId}`}
									target="_blank"
								>
									Abrir conversa no Botmaker
								</Link>
							</Typography>
						</Tooltip>
					)}
				</Box>
				<Box width={48} minWidth={48}>
					<Tooltip title="Ligar">
						<IconButton
							size="medium"
							color="inherit"
							onClick={() => {
								callPhone(cliente.telefone);
							}}
							className={classes.iconButtom}
						>
							<CallIcon fontSize="small" />
						</IconButton>
					</Tooltip>
				</Box>
			</Box>

			{(associado.nome || associado.prontuario) && (
				<Box display="flex" p={0} className={classes.detail}>
					<Box width={56} minWidth={56}>
						<PersonIcon fontSize="large" className={classes.icon} />
					</Box>
					<Box flexGrow={1}>
						<Typography variant="subtitle2">Associado:</Typography>
						<Typography variant="subtitle1">{associado.nome}</Typography>
						{associado.prontuario && (
							<Typography variant="caption">
								Prontuário: {associado.prontuario}
							</Typography>
						)}
					</Box>
				</Box>
			)}

			{(cliente.nome || cliente.cpf) && (
				<Box display="flex" p={0} className={classes.detail}>
					<Box width={56} minWidth={56}>
						<PersonIcon fontSize="large" className={classes.icon} />
					</Box>
					<Box flexGrow={1}>
						<Typography variant="subtitle2">Cliente:</Typography>
						<Typography variant="subtitle1">{cliente.nome}</Typography>
						{(cliente.cpf || cliente.cnpj) &&
							origem !== ORIGEM.SHIP_FROM_STORE && (
								<Typography variant="caption">
									CPF / CNPJ:{" "}
									{cliente.cpf
										? documentsMask(cliente.cpf, "cliente")
										: documentsMask(cliente.cnpj, "cnpj")}
								</Typography>
							)}
						<br />
						{/* {cliente.email && <Typography variant="caption">
            E-mail: {cliente.email}
          </Typography>} */}
					</Box>
				</Box>
			)}

			{!(
				tipoEntrega === "RETIRADA" || origem === ORIGEM.PEGUE_NA_LOJA_HOJE
			) && (
				<Box display="flex" p={0} className={classes.detail}>
					<Box width={56} minWidth={56}>
						<RoomIcon fontSize="large" className={classes.icon} />
					</Box>
					<Box flexGrow={1}>
						<Typography variant="subtitle2">
							{cliente.endereco}
							{cliente.numero && <>, {cliente.numero}</>}
						</Typography>

						<Typography variant="body2">
							{cliente.complemento && `${cliente.complemento}, `}
							{cliente.bairro && `${cliente.bairro}, `}
							{cliente.cidade && `${cliente.cidade}`}
							{cliente.uf && ` - ${cliente.uf}`}
							{cliente.cep && ` | ${cliente.cep}`}
						</Typography>
						{cliente.referencia && (
							<Typography variant="body2">
								Referência: ${cliente.referencia}
							</Typography>
						)}
					</Box>
				</Box>
			)}

			{(recebedor.nome || recebedor.documento) && (
				<Box display="flex" p={0} className={classes.detail}>
					<Box width={56} minWidth={56}>
						<AssignmentIndIcon fontSize="large" className={classes.icon} />
					</Box>
					<Box flexGrow={1}>
						<Typography variant="subtitle2">Recebedor:</Typography>
						<Typography variant="subtitle1">{recebedor.nome}</Typography>
						{recebedor.documento && origem !== ORIGEM.SHIP_FROM_STORE && (
							<Typography variant="caption">
								Documento: {documentsMask(recebedor.documento, "recebedor")}
							</Typography>
						)}
					</Box>
				</Box>
			)}

			{origem === ORIGEM.PEGUE_NA_LOJA && (
				<Box display="flex" p={0} className={classes.detail}>
					<Box width={56} minWidth={56}>
						<LocalOfferOutlined fontSize="large" className={classes.icon} />
					</Box>
					<Box flexGrow={1}>
						<Typography variant="subtitle2">Tipo de Oferta:</Typography>
						<Typography variant="subtitle1">
							{erpOrigem === "UMBRELLA" ? "CD Americanas" : "Parceiros"}
						</Typography>
					</Box>
				</Box>
			)}

			{notaFiscal && !notaFiscal.chave && page !== "new-orders" && (
				<Box display="flex" p={0} className={classes.detail}>
					<Box width={56} minWidth={56}>
						<DescriptionIcon
							className={clsx(classes.icon, classes.notaFiscalAwaiting)}
						/>
					</Box>
					<Box flexGrow={1}>
						<Typography variant="subtitle2">Nota Fiscal:</Typography>
						<Typography variant="subtitle1" className={classes.textSubtitle}>
							Aguardando emissão da nota fiscal
						</Typography>
					</Box>
				</Box>
			)}
			{notaFiscal && notaFiscal.chave && (
				<>
					<Box display="flex" p={0} className={classes.detail}>
						<Box width={56} minWidth={56}>
							<DescriptionIcon fontSize="large" className={classes.icon} />
						</Box>
						<Box flexGrow={1}>
							<Typography variant="subtitle2">Nota Fiscal:</Typography>
							<p className={classes.noMargin}>
								<Typography variant="caption">
									<b>Chave:</b> {notaFiscal.chave}
								</Typography>
							</p>
							<p className={classes.noMargin}>
								<Typography variant="caption">
									<b>Data de Recebimento:</b>{" "}
									{new Date(notaFiscal.dataEmissao).toLocaleDateString()}{" "}
									{new Date(notaFiscal.dataEmissao).toLocaleTimeString()}
								</Typography>
							</p>
						</Box>
					</Box>
					{getQRCode(notaFiscal)}
				</>
			)}
			{notaFiscalDevolucao && (
				<>
					<Box display="flex" p={0} className={classes.detail}>
						<Box width={56} minWidth={56}>
							<DescriptionIcon fontSize="large" className={classes.icon} />
						</Box>
						<Box flexGrow={1}>
							<Typography variant="subtitle2">Nota de Devolução:</Typography>
							<p className={classes.noMargin}>
								<Typography variant="caption">
									<b>Chave:</b> {notaFiscalDevolucao.chave}
								</Typography>
							</p>
							<p className={classes.noMargin}>
								<Typography variant="caption">
									<b>Data de Recebimento:</b>{" "}
									{new Date(
										notaFiscalDevolucao.dataEmissao,
									).toLocaleDateString()}{" "}
									{new Date(
										notaFiscalDevolucao.dataEmissao,
									).toLocaleTimeString()}
								</Typography>
							</p>
						</Box>
					</Box>
					{getQRCode(notaFiscalDevolucao)}
				</>
			)}
		</>
	);
}

export default withStyles(styles, { withTheme: true })(Details);
